import { API_CALL } from 'actions/actionConstants'
import { FETCH_WRAPPED, FETCH_WRAPPED_TOTALS } from 'actions/apiActionConstants'
import { getMyWrapped, getWrappedTotals } from 'api/wrapped/wrapped'
import { AppAction } from './types/ActionTypes'

export function fetchWrapped(): AppAction {
  return async(dispatch, getState) => {
    const state = getState()
    const wrappedState = state.wrapped

    // Skip if already fetching or fetched
    if (wrappedState.state === 'loading' || wrappedState.state === 'done') {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_WRAPPED,
      request: () => getMyWrapped(),
    })
  }
}

export function fetchWrappedTotals(): AppAction {
  return async(dispatch, getState) => {
    const state = getState()
    const totalsState = state.wrapped.totals

    // Skip if already fetching or fetched
    if (totalsState?.state === 'loading' || totalsState?.state === 'done') {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_WRAPPED_TOTALS,
      request: () => getWrappedTotals(),
    })
  }
}
